import styles from "./PaywallsForm.module.scss";
import Button from "../../Button";
import { useFormik } from "formik";
import * as yup from "yup";
import cn from "classnames";

const validationSchema = yup.object({
  email: yup.string().email().required(),
  fullName: yup.string().required(),
});

const PaywallsForm = ({ submitHandler }) => {
  const formik = useFormik({
    initialValues: {
      email: "",
      fullName: "",
    },
    validateOnChange: false,
    validationSchema,
    onSubmit: (values) => {
      submitHandler(values);
      formik.resetForm();
    },
  });

  return (
    <form className={styles.wrapper} onSubmit={formik.handleSubmit}>
      <h3 className={styles.title}>Subscribe to be notified of new paywalls</h3>

      <div className={styles.inputs_wrapper}>
        <input
          className={cn(
            styles.input,
            formik.touched.fullName && formik.errors.fullName && styles.error
          )}
          id="fullName"
          placeholder="Full name..."
          value={formik.values.fullName}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />

        <input
          id="email"
          className={cn(
            styles.input,
            formik.touched.email && formik.errors.email && styles.error
          )}
          placeholder="Your email..."
          value={formik.values.email}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
      </div>

      <Button
        className={styles.button}
        title="Subscribe"
        fullWidth
        type="submit"
      />
    </form>
  );
};

export default PaywallsForm;
